import { JSX, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { resolveStartUrl } from "../utils/resolveStartUrl";

export const START_REDIRECT_COUNTDOWN_SECONDS = 5;

export function startRedirectCountdownMessage(seconds: number): string {
    const unit = seconds === 1 ? "seconde" : "seconden";

    return `Je wordt over ${seconds} ${unit} doorgestuurd naar de startpagina.`;
}

interface Props {
    logoSrc: string;
    startUrl?: string;
    seconds?: number;
    redirect?: (url: string) => void;
}

export const RedirectToStartCountdown = (props: Props): JSX.Element => {
    const seconds = props.seconds ?? START_REDIRECT_COUNTDOWN_SECONDS;
    const [remaining, setRemaining] = useState(seconds);

    useEffect(() => {
        const startUrl = resolveStartUrl(props.startUrl);
        const redirect =
            props.redirect ?? ((url: string) => window.location.replace(url));

        if (!startUrl) {
            console.error("VITE_START_URL must be set");
            return;
        }

        const interval = window.setInterval(() => {
            setRemaining((current) => Math.max(current - 1, 0));
        }, 1000);

        const timeout = window.setTimeout(() => {
            redirect(startUrl);
        }, seconds * 1000);

        return () => {
            window.clearInterval(interval);
            window.clearTimeout(timeout);
        };
    }, [props.redirect, props.startUrl, seconds]);

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "1.5rem",
                backgroundColor: "white",
                zIndex: 50,
            }}
        >
            <motion.img
                src={props.logoSrc}
                alt="Loading"
                animate={{
                    scale: [1, 1.1, 1],
                    opacity: [1, 0.7, 1],
                }}
                transition={{
                    duration: 1.5,
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
                style={{
                    width: "16rem",
                    height: "16rem",
                    objectFit: "contain",
                }}
            />
            <p style={{ fontSize: "1.125rem", textAlign: "center" }}>
                {startRedirectCountdownMessage(Math.max(remaining, 1))}
            </p>
        </div>
    );
};
